import { SurveyResponseTypes } from '../shared/response-types';

export interface ContextQuestionModel {
  surveyId: string;
  questionId: string;
  responseId: string;
  questionResponseId: string;
  responseType: SurveyResponseTypes;
  title: string;
  response: number;
}
